import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { MachinesPopup } from "./MachinesPopup";

export default function MachinesTable() {
   const { loading, data } = useCollection("machines");
   const columns = [
      {
         title: "Machine",
         dataIndex: "machine",
      },
      {
         title: "Worker Costs",
         dataIndex: ["costs", "worker"],
         align: "center",
         sorter: {
            compare: (a, b) => a.costs.worker - b.costs.worker,
         },
      },
      {
         title: "Electricity",
         dataIndex: ["costs", "electricity"],
         align: "center",
         sorter: {
            compare: (a, b) => a.costs.electricity - b.costs.electricity,
         },
      },
      {
         title: "Amortization",
         dataIndex: ["costs", "amortization"],
         align: "center",
         sorter: {
            compare: (a, b) => a.costs.amortization - b.costs.amortization,
         },
      },
      {
         title: "Speed",
         dataIndex: "speed",
         align: "center",
         sorter: {
            compare: (a, b) => a.speed - b.speed,
         },
      },
      {
         title: "ALSM",
         dataIndex: "alsm",
         align: "center",
         sorter: {
            compare: (a, b) => a.alsm - b.alsm,
         },
      },
      {
         title: "Stations",
         dataIndex: "stations",
         align: "center",
         sorter: {
            compare: (a, b) => a.stations - b.stations,
         },
      },
      {
         render: (value) => (
            <MachinesPopup title={value.machine} costs={value.costs} id={value.id} alsm={value.alsm} stations={value.stations} speed={value.speed} />
         ),
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
